import { useQuery, type QueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface ScheduleEvent {
  id: number;
  EventName: string;
  EventType: string;
  Icon: string;
  DayOfWeek: number;
  EventTime: string;
  Status: number;
  DurationSeconds: number;
  IsActive: number | boolean;
  event_timestamp: number;
}

export interface ScheduleResponse {
  status: string;
  data: {
    schedules: ScheduleEvent[];
  };
}

export const SCHEDULE_QUERY_KEY = ['schedule'] as const;

export async function fetchSchedule(): Promise<ScheduleEvent[]> {
  const { data } = await api.get<ScheduleResponse>('/api/v1/schedule');
  return data.data?.schedules ?? [];
}

export function useSchedule() {
  return useQuery({
    queryKey: SCHEDULE_QUERY_KEY,
    queryFn: fetchSchedule,
    staleTime: 300_000,
    placeholderData: (prev) => prev,
  });
}

export function prefetchSchedule(queryClient: QueryClient): void {
  void queryClient.prefetchQuery({
    queryKey: SCHEDULE_QUERY_KEY,
    queryFn: fetchSchedule,
    staleTime: 300_000,
  });
}
